var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(-1503 -1221)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(1503 1221)",
    fill: "#d16c3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mail-2",
    "data-name": "mail",
    transform: "translate(1517 1240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M30.4,76H2.93A2.934,2.934,0,0,0,0,78.93V96.507a2.934,2.934,0,0,0,2.93,2.93H30.4a2.933,2.933,0,0,0,2.93-2.93V78.93A2.932,2.932,0,0,0,30.4,76Zm-.41,1.953-11.255,11.2a2.93,2.93,0,0,1-4.145,0L3.34,77.953ZM1.953,96.11V79.328l8.44,8.4Zm1.388,1.374L11.778,89.1l1.436,1.429a4.883,4.883,0,0,0,6.9,0l1.438-1.43,8.436,8.383ZM31.379,96.11l-8.44-8.386,8.44-8.4Z",
    transform: "translate(0 -76)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.633a9631854d37454b21e6323d2cebcc.svg";
export { ForwardRef as ReactComponent };